import React, { FC } from 'react';
import { CollapsibleSection as SectionBase, CollapsibleSectionProps } from '@cld/widget-demos-common';
import { useAnalytics } from '../../../hooks/useAnalytics';

export const Section: FC<CollapsibleSectionProps> = (props) => {
  const analytics = useAnalytics();

  return (
    <SectionBase
      {...props}
      onToggle={(newState) => analytics('show-hide', `${newState ? 'open' : 'close'} ${props.title.toLowerCase()} panel`)}
    />
  );
};
